import { PAGE_SIZE, usePagedFeed } from "./use-paged-feed";

import type { Database } from "../../../__definitions__/database-definitions";
import type { PagedFeed } from "./use-paged-feed";

export type UpcomingSend =
  Database["public"]["Functions"]["upcoming_communications"]["Returns"][number];

/**
 * The Communications sending soonest, a page at a time, as the old home page's Upcoming tab lists
 * them: none triggered by a person's date. With `userEdited`, only those the user has edited
 * themselves.
 */
export function useUpcomingSends(userEdited: boolean): PagedFeed<UpcomingSend> {
  return usePagedFeed(
    async ({ supabase, account_id }, offset) => {
      const { data, error } = await supabase.rpc("upcoming_communications", {
        account_id_: account_id,
        size_: PAGE_SIZE,
        offset_: offset,
        user_edited_: userEdited,
      });
      if (error) throw error;
      return data;
    },
    [userEdited],
  );
}
